/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export enum TokenType {
	CLIENT = 'CLIENT',
	REMEMBER_ME = 'REMEMBER_ME',
	SECOND_FACTOR = 'SECOND_FACTOR'
}
